export const home = {
  hero: {
    pill: {
      label: 'Consumers',
      text: 'Order food now'
    },

    heading: {
      serve: 'Serve',
      more_orders: 'more orders',
      to_your_restaurant: 'to your restaurant with Bistroo',
    },

    saving_time: 'We\'re saving time and increase your profit.',
    boosting_business: 'We\'re boosting your online business.',

    header_mockup_alt: 'Dashboard & Landing page',
    partners_alt: 'Trusted by our partners'
  },
  landing_pages: {
    heading: {
      create: 'Create',
      your_restaurant: 'your restaurant\'s',
      shop_in_minutes: 'shop and website in minutes'
    },

    personalized_webshop: 'A personalized webshop and website for your restaurant, online within 1 business day.',
    start_free: 'Start for free today and choose from 1000+ customizable designs.',

    actions: {
      create_your_website: 'Create your website',
    }
  },
  key_features: {
    pill: {
      label: 'Key features',
      text: 'All you need to know',
    },

    heading: 'Everything you need to manage digital ordering',

    personalize_order_experience: 'Personalize your customers\' ordering experience with our fully customizable online',
    boost_sales: 'food ordering system. Discover the tools to grow your restaurant and boost sales.',

    cards: {
      order_management_with_ease: {
        title: 'Order management with ease.',
        text: 'Personalize your customers\' ordering experience with our fully customizable online dashboard.',
        button: 'Explore dashboard'
      },
      plug_and_play: {
        title: 'Plug-and-play.',
        text: 'Start within minutes with our self-installing POS device or use your own phone or laptop'
      },
      peak_times: {
        title: 'Control over peak times and busy hours.',
        text: 'Adjust every setting in real time.'
      },
      instant_payments: {
        title: 'Instant payments.',
        text: 'Payout your orders any-time',
        img_alt: 'POS handheld'
      },
      many_more: {
        title: 'And many more!',
        text: 'Want more details about the best features?',
        button: 'Explore all features',
      }
    }
  },
  products: {
    pill: {
      label: 'Bistroo Products',
      text: 'All you need to know',
    },
    heading: 'Choose the Bistroo products that are the perfect recipe for your business',
    stop_overspending: 'Stop overspending on pricey software with unused features, save costs and increase efficiency.',
    productivity_increase: 'We typically see a 20% increase in productivity and revenue with optimal use of our solutions.',
    start_for_free: 'Start for free now',

    cards: {
      bistroo: 'Bistroo',
      webshop: {
        title: 'Webshop',
        description: 'A restaurant focussed webshop with our comprehensive management module.',
        img_alt: 'Bistroo Webshop',
        features: [
          'Alles van een Webshoppakket',
          'Volledige landingspagina',
          'Eigen domein incl. hosting'
        ],
        action: 'Explore webshop'
      },
      page: {
        title: 'Page',
        description: 'No time or expertise to create your own website? A page fully managed at an affordable price.',
        img_alt: 'Bistroo Page',
        features: [
          'No cure, no pay',
          'Trek nieuwe klanten aan',
          'Profiteer van Bistroo marketing',
        ],
        action: 'Explore page'
      },
      qr: {
        title: 'QR',
        description: 'Taking orders has never been easier. Let your guests order through their phone.',
        img_alt: 'Bistroo QR',
        features: [
          'Terrasoplossing',
          'QR stickers',
          'Gekoppeld met Bistroo betaal',
        ],
        action: 'Explore QR'
      }
    }
  },
  integrations: {
    heading: 'Use Plug-and-play integrations',
    text: 'Manage and optimize online food orders by integrating with your favorite tools and POS systems to automate time-consuming processes. We\'ve already done the work—you simply select what you need! It\'s that easy.',
    action: 'Explore integrations'
  },
  testimonials: {
    pill: {
      label: 'Client stories',
      text: 'What entrepreneurs say'
    },

    heading: 'These entrepreneurs have already tried Bistroo and said..',
    empowered_our_clients: 'Learn how our solutions have empowered our clients to achieve success!',

    testimonials: {
      hero: {
        img_alt: 'Mondie Scheepers - Two-B by Mondie',
        text: '"Since working with Bistroo, our to-go orders have increased, and any issues are quickly resolved by their response team."',
        author: 'Mondie Scheepers',
        company: 'Two-B by Mondie',
        action: 'Read the full story'
      },

      reviews: {
        one: {
          text: '"Since we started working with Bistroo, we\'ve seen our take-away numbers go up! And whenever something doesn’t go smoothly, the team is easy to reach and they solve the issue right away."',
          author: 'Roberta',
          company_role: 'Hostess, Il Municipio',
          action: 'Read story',
        },
        two: {
          text: '"Bistroo has proven to be the perfect partner as an online ordering solution. For guests, there’s a clear and user-friendly website. For management, the ability to quickly adapt with current discounts and promotions."',
          author: 'Hamza',
          company_role: 'Owner, Grillroom Istanbul',
          action: 'Read story',
        },
        three: {
          text: '"Bistroo is super simple and super effective; in no time, you’ll have a fully stocked online food store and can get back to doing what you love—making your guests happy with delicious food and drinks!"',
          author: 'Henk Boom',
          company_role: 'Owner, cafetaria D\'n Boom',
          action: 'Read story',
        }
      }
    }
  }
}